/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Mk_Feat1_BodyInputs */

const es_exp_mk_feat1_body = /** @type {(inputs: Exp_Mk_Feat1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explora travesías con plazas disponibles por zona, fecha y tipo de barco.`)
};

const gl_exp_mk_feat1_body = /** @type {(inputs: Exp_Mk_Feat1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explora travesías con prazas dispoñibles por zona, data e tipo de barco.`)
};

const en_exp_mk_feat1_body = /** @type {(inputs: Exp_Mk_Feat1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse trips with places available by area, date and boat type.`)
};

/**
* | output |
* | --- |
* | "Browse trips with places available by area, date and boat type." |
*
* @param {Exp_Mk_Feat1_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const exp_mk_feat1_body = /** @type {((inputs?: Exp_Mk_Feat1_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Mk_Feat1_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_exp_mk_feat1_body(inputs)
	if (locale === "en") return en_exp_mk_feat1_body(inputs)
	return es_exp_mk_feat1_body(inputs)
});